import { useState, useCallback } from 'react'
export const useAlert = () => {
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'neutral',
    message: '',
  })

  const showAlert = useCallback((message, variant = 'neutral') => {
    setAlertState({
      show: true,
      variant,
      message,
    })
  }, [])

  const hideAlert = useCallback(() => {
    setAlertState((prev) => ({
      ...prev,
      show: false,
    }))
  }, [])

  const showError = useCallback(
    (message) => {
      showAlert(message, 'error')
    },
    [showAlert]
  )

  const showSuccess = useCallback(
    (message) => {
      showAlert(message, 'success')
    },
    [showAlert]
  )

  const showWarning = useCallback(
    (message) => {
      showAlert(message, 'warning')
    },
    [showAlert]
  )

  const showInfo = useCallback(
    (message) => {
      showAlert(message, 'neutral')
    },
    [showAlert]
  )

  return {
    show: alertState.show,
    variant: alertState.variant,
    message: alertState.message,
    showAlert,
    hideAlert,
    showError,
    showSuccess,
    showWarning,
    showInfo,
  }
}
